import { Divider, DividerProps } from "@mui/material";

export const Break = ({ className, ...props }: DividerProps) => {
  return <Divider {...props} className={className} />;
};
